import gameData from "../../gameData";
import * as ABCya from '@abcya/abcya_phaser';
import { displayDonuts } from "./displayQuestionParts";
import sKey from "../../SoundAssetKeys";

/* This file handles tweens that are longer than just a few lines,
    if a tween is simple it is going to be in the file with the 
    objects being tweened */

export function incorrectTimeline(scene)
{
    const incorrectTimeline = scene.tweens.createTimeline();
    const tempArr = [];

    stopIdle();

    for(let each in gameData.currentDonuts)
    {
        tempArr.push(gameData.currentDonuts[each].image)
    }
    tempArr.push(scene.selector1);
    tempArr.push(scene.selector2);
    //tempArr.push(scene.back);
    //console.log(tempArr)

    for(let each in gameData.currentDonuts)
    {
        gameData.currentDonuts[each].image.disableInteractive();
    }

    incorrectTimeline.add({
        targets: scene.incorrectX,
        props:{
            alpha:{value:1, duration:500, ease:Phaser.Math.Easing.Quadratic.In},
            y:{value:{start:scene.incorrectX.y+30, to:scene.incorrectX.y},duration:300},
            angle:{value:5, duration:50, delay:300,ease:Phaser.Math.Easing.Quadratic.In} 
        }
    });

    incorrectTimeline.add({
        targets: scene.incorrectX,
        angle:-5, 
        duration:100,  
        ease:Phaser.Math.Easing.Quadratic.Out     
    });

    incorrectTimeline.add({
        targets: scene.incorrectX,
        angle:5, 
        duration:100,  
        ease:Phaser.Math.Easing.Quadratic.Out     
    });

    incorrectTimeline.add({
        targets: scene.incorrectX,
        angle:-5, 
        duration:100,  
        ease:Phaser.Math.Easing.Quadratic.Out     
    });

    incorrectTimeline.add({
        targets: scene.incorrectX,
        angle:0, 
        duration:50,  
        ease:Phaser.Math.Easing.Quadratic.Out,
        completeDelay:400
    });

    incorrectTimeline.add({
        targets: scene.incorrectX,
        props:{
            alpha:{value:0, duration:200, ease:Phaser.Math.Easing.Quadratic.In},
            y:{value:"+=30",duration:300}
        },
        onComplete:()=>{
            scene.incorrectX.y -= 30;
            for(let each in gameData.currentDonuts)
            {
                gameData.currentDonuts[each].image.setInteractive();
            }
        }
    });

    incorrectTimeline.on('start',()=>{
        scene.custSound.playSoundCustom(sKey._incorrect_answer);
    });

    incorrectTimeline.play();
    setTimeout(()=>{
        shakeTimeline(scene,scene.back,1,150).play();
        shakeTimeline(scene,tempArr,4,150).play();
    },300);

    incorrectTimeline.on('complete',idleDonuts);

    return incorrectTimeline;
}

export function stopIdle()
{
    const dArray = gameData.currentDonuts;
    const scene = dArray[0].image.scene;
    for(let each in dArray)
    {
        scene.tweens.killTweensOf(dArray[each].image);
        if(dArray[each].image.y != dArray[each].yData)
        {
            const time = (dArray[each].yData - dArray[each].image.y) * 40;//keeps the speed the same
            ABCya.Tweens.addTween(dArray[each].image,time,{y:dArray[each].yData},Phaser.Math.Easing.Quadratic.InOut,()=>{

            })
        }
    }
}

export function correctTimeline(scene)
{
    const correctTimeline = scene.tweens.createTimeline();

    stopIdle();

    correctTimeline.add({
        targets: scene.correctX,
        props:{
            alpha:{value:1, duration:400, ease:Phaser.Math.Easing.Quadratic.In},
            scale:{value:{start:1.5, to:1},duration:400, ease:Phaser.Math.Easing.Quadratic.In},
        }
    });

    correctTimeline.add({
        targets: scene.correctX,
        angle:-1, 
        duration:25,  
        ease:Phaser.Math.Easing.Quadratic.Out     
    });

    correctTimeline.add({
        targets: scene.correctX,
        angle:1, 
        duration:50,  
        ease:Phaser.Math.Easing.Quadratic.Out     
    });

    correctTimeline.add({
        targets: scene.correctX,
        angle:-1, 
        duration:50,  
        ease:Phaser.Math.Easing.Quadratic.Out   
    });

    correctTimeline.add({
        targets: scene.correctX,
        angle:0, 
        duration:25,  
        ease:Phaser.Math.Easing.Quadratic.Out,
        completeDelay:800,
    });

    correctTimeline.add({
        targets: scene.correctX,
        alpha:0, 
        duration:200,  
        ease:Phaser.Math.Easing.Quadratic.In
    });

    correctTimeline.on('start',()=>{
        scene.custSound.playSoundCustom(sKey._correct_answer);
    });

    correctTimeline.play();

    return correctTimeline;
}

export function donutsOut(scene)
{
    const dArray = gameData.currentDonuts;//short for donut array
    let timeline;
    let counter = 0;
    //console.log("out");

    stopIdle();

    for(let d = 0; d < 5; d++)
    {
        timeline = tweenOut(dArray[d].image,d*200);
        timeline.on('complete',()=>{
            counter++;
            if(counter === dArray.length)
            {
                gameData.currentDonuts = [];
                scene.events.emit('cleanDonuts');
               displayDonuts(gameData.layouts[gameData.questionNum],scene);
            }
        });
        timeline.on('start',()=>{
            scene.custSound.playSoundCustom(sKey._donuts_enter_leave);
        });
    }
    
    if(dArray.length > 6)
    {
        for(let d = 9; d > 4; d--)
        {
            timeline = tweenOut(dArray[d].image,Math.abs(d-9)*200,"right");
            timeline.on('complete',()=>{
                counter++;
                if(counter === dArray.length)
                {
                    gameData.currentDonuts = [];
                    scene.events.emit('cleanDonuts');
                    if(gameData.questionNum < 12)
                    {
                        displayDonuts(gameData.layouts[gameData.questionNum],scene);
                    }
                    else
                    {
                        scene.events.emit('complete');
                    }
                }
            });
        }
        return timeline;

    }

    function tweenOut(object,delay,leftRight = "left")
    {
        const scene = object.scene;
        const timeline = scene.tweens.createTimeline();
        const xEnd = (leftRight === "left") ? 0-object.width*object.scale : 1098+object.width*object.scale;

        timeline.add({
            targets:object,
            delay:delay,
            alpha:{start:1,to:1},
            duration:800,
            ease:Phaser.Math.Easing.Quadratic.InOut,
            x:xEnd,
            angle:360,
        });

        timeline.play();
        return timeline;
    }
}

export function donutsIn(scene)
{
    const dArray = gameData.currentDonuts;//short for donut array
    let counter = 0;
    const delay = 200;
    
    for(let d = 0; d < 5; d++)
    {
        const timeline = tweenIn(scene,dArray[d].image,d*delay);
        timeline.on('complete',()=>{
            timeComplete();
        });
        timeline.on('start',()=>{
            scene.custSound.playSoundCustom(sKey._donuts_enter_leave);
        });
    }

    if(dArray.length > 6)
    {
        for(let d = 9; d > 4; d--)
        {
            const timeline = tweenIn(scene,dArray[d].image,Math.abs(d-9)*delay,"right");
            timeline.on('complete',()=>{
                timeComplete();
            });
        }
    }

    function tweenIn(scene,object,delay,leftRight = "left")
    {
        const timeline = scene.tweens.createTimeline();
        const xStart = (leftRight === "left") ? 1098+object.width*object.scale :  0-object.width*object.scale;

        timeline.add({
            targets:object,
            delay:delay,
            alpha:{start:1,to:1},
            duration:800,
            ease:Phaser.Math.Easing.Quadratic.InOut,
            x:{start:xStart, to:object.x},
            angle:360
        });

        timeline.play();
        return timeline;
    }

    function timeComplete()
    {
        counter++;
        if(counter === dArray.length)
        {
            for(let each in dArray)
            {
                dArray[each].image.setInteractive();
            }

            idleDonuts();
        }
    }
}

export function textIn(scene,text,ySet = false,y)
{

    const timeline = scene.tweens.createTimeline();

    timeline.add({
        targets: scene.questionText,
        duration: 500,
        x:2100,
        ease: Phaser.Math.Easing.Quadratic.InOut    
    });

    timeline.add({
        targets: scene.questionText,
        duration: 700,
        x: 512,
        ease: Phaser.Math.Easing.Quadratic.InOut,
        onStart:()=>{
            scene.questionText.x = -1000;
            scene.questionText.text = text;
            scene.questionText.setDepth(6);
            if(ySet)scene.questionText.y = y;
        }
    });

    timeline.play();

    return timeline
}

function textWobble(text)
{
    const TextWiggle = Scene.tweens.createTimeline({loop:-1});

    TextWiggle.add({
        targets: MenuText,
        duration: 500,
        angle: 1,
        //scale:.9,
        yoyo:true,
        ease:Phaser.Math.Easing.Quadratic.InOut
    });

    TextWiggle.add({
        targets: MenuText,
        duration: 500,
        angle: -1,
        //scale:1.1,
        yoyo:true,
        ease:Phaser.Math.Easing.Quadratic.InOut
    });
}

export function idleDonuts()
{
    const donuts = gameData.currentDonuts;
    const qNum = gameData.questionNum;

    function leftRight()
    {
        let counter = 0;
        for(let num = 0; num < donuts.length; num++)
        {
            if(qNum === gameData.questionNum){
                const tween = ABCya.Tweens.addTween(donuts[num].image,200,{y:"-=5", yoyo:true, delay:120*num+10,completeDelay:2000},Phaser.Math.Easing.Quadratic.InOut);
                tween.on('complete',(tween,tatrributes,tweened)=>{
                    counter++;
                    if(counter === donuts.length && qNum === gameData.questionNum)
                    {
                        rightLeft();
                    }
                })
            }
        }
    }
    
    
    function rightLeft()
    {
        let counter = 0;
        for(let num = donuts.length - 1; num > -1; num--)
        {
            const tween = ABCya.Tweens.addTween(donuts[num].image,200,{y:"-=5", delay:(120*(donuts.length-num)+10),yoyo:true,completeDelay:2000},Phaser.Math.Easing.Quadratic.InOut);
            tween.on('complete',()=>{
                counter++;
                if(counter === donuts.length && qNum === gameData.questionNum)
                {
                    leftRight();
                }
            })
        }
    }
    leftRight();
}

function shakeTimeline(scene,objects,shakeDegree = 3,duration=70)
{
    const timeline = scene.tweens.createTimeline();

    timeline.add({
        targets: objects,
        angle:-1*shakeDegree, 
        duration:duration/2,  
        ease:Phaser.Math.Easing.Quadratic.Out     
    });

    timeline.add({
        targets: objects,
        angle:shakeDegree, 
        duration:duration,  
        ease:Phaser.Math.Easing.Quadratic.Out     
    });

    timeline.add({
        targets: objects,
        angle:-1*shakeDegree, 
        duration:duration,  
        ease:Phaser.Math.Easing.Quadratic.Out   
    });

    timeline.add({
        targets: objects,
        angle:0, 
        duration:duration/2,  
        ease:Phaser.Math.Easing.Quadratic.Out
    });

    return timeline
}